import { CURRENT_USER } from "../contants/constants";
import { WebStorageService } from "./WebStorageService";

export class BaseService {
    private readonly _controller:string;
    private webStorageService = new WebStorageService();
    constructor(controller:string){
        this._controller = controller;
    }

    public get EndPoint() {
        return `${process.env.REACT_APP_API_URL}/api/${this._controller}`;
    }

    public get AuthJsonHeader() {
        if (this.webStorageService.getJson(CURRENT_USER) != null) {
            return { 'Content-Type': 'application/json', 'authorization': 'Bearer ' + this.webStorageService.getJson(CURRENT_USER).Token };
        }
        return this.UnAuthJsonHeader;
    }

    public get UnAuthJsonHeader() {
        return {'Content-Type': 'application/json;'};
    }
}